import { LoginService } from 'app/view/login/login.service';
import { Component, OnInit, OnChanges } from "@angular/core";
import "rxjs/add/operator/filter";

import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET, ActivatedRouteSnapshot, UrlSegment } from "@angular/router";

interface IBreadcrumb {
    label: string;
    params?: Params;
    url: string;
}

class Pagina {
    label: string;
    url: string;
}

declare var $: any;

@Component({
    moduleId: module.id,
    selector: "breadcrumb",
    template: `
        <nav class="fondo-color_one separador-abajo box-header">
            <ul class="nav float-left">
                <li class="nav-item mr-2">
                    <div class="menu-trigger" (click)="dragSidebar()">
                        <div class="line-wrap">
                            <div class="line top"></div>
                            <div class="line center"></div>
                            <div class="line bottom"></div>
                        </div>
                    </div>
                </li>
                <!--li class="breadcrumb-item px-0 py-2" *ngFor="let breadcrumb of breadcrumbs; let last = last" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
                    <a class="text-inacal" *ngIf="!last" [routerLink]="[breadcrumb.url]">{{breadcrumb.label}}</a>
                    <span class="text-muted" *ngIf="last">{{breadcrumb.label}}</span>
                </li-->
                <li class="breadcrumb-item px-0 py-2">
                    <span class="text-muted text-header"></span>
                </li>
            </ul>
            <ul class="nav justify-content-end float-right">
                <li class="py-2 pr-1">
                    <a routerLink="#" (click)="Logout()">
                        Salir
                        <i class="material-icons material-icons_direction">exit_to_app</i>
                    </a>
                </li>
            </ul>
        </nav>
    `,
    styles: ['']
})

export class BreadcrumbComponent implements OnInit, OnChanges {

    constructor(private activatedRoute: ActivatedRoute, private router: Router, private loginService: LoginService) {
        this.breadcrumbs = [];
    }


    breadcrumbs: Array<Pagina>;
    breadcrumb = new Pagina;

    obtenerNavegacion() {
        this.breadcrumbs = new Array<Pagina>();
        let root: ActivatedRoute = this.activatedRoute.root;
        this.breadcrumbs = this.getBreadcrumbs(root);
    }

    getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {

        const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
        let children: ActivatedRoute[] = route.children;

        if (children.length === 0) {
            return breadcrumbs;
        }

        for (let child of children) {
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }

            let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");
            url += `/${routeURL}`;

            let breadcrumb: IBreadcrumb = {
                label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
                params: child.snapshot.params,
                url: url
            };

            breadcrumbs.push(breadcrumb);
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
        return breadcrumbs;
    }

    ngOnInit() {
        this.obtenerNavegacion();
    }
    ngOnChanges() {
        //console.log(" cambio ");
    }


    Logout() {
        this.loginService.logout();
        this.router.navigate(['/iniciar-sesion']);

    }
    dragSidebar() {
        //console.log("entre");
        $(".box-sidebar").toggleClass("Drag");
        $(".box-main").toggleClass("Drag");
    }
    closeInfoShow() {
        $(".box-info_contendor").removeClass("box-info_contendorShow");
        $(".box-detalles").removeClass("paddingRigth");
    }
}



// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/breadcrumb/breadcrumb.component.ts